import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

type BadgeVariant = 'primary' | 'muted' | 'outline' | 'sand'

interface BadgeProps {
    children: ReactNode
    className?: string
    variant?: BadgeVariant
}

const VARIANTS: Record<BadgeVariant, string> = {
    primary: 'bg-primary/10 text-primary',
    muted: 'bg-secondary text-secondary-foreground',
    outline: 'border border-border text-muted-foreground',
    sand: 'bg-sand/25 text-sand-foreground'
}

export const Badge: FC<BadgeProps> = ({ children, className, variant = 'primary' }) => {
    return (
        <span
            className={cn(
                'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium tracking-tight',
                VARIANTS[variant],
                className
            )}
        >
            {children}
        </span>
    )
}
